import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPaperclip = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19.5 32C15.4 32 12 28.6 12 24.5V13.5C12 10.5 14.5 8 17.5 8C20.5 8 23 10.5 23 13.5V23.5C23 25.4 21.4 27 19.5 27C17.6 27 16 25.4 16 23.5V15C16 14.4 16.4 14 17 14C17.6 14 18 14.4 18 15V23.5C18 24.3 18.7 25 19.5 25C20.3 25 21 24.3 21 23.5V13.5C21 11.6 19.4 10 17.5 10C15.6 10 14 11.6 14 13.5V24.5C14 27.5 16.5 30 19.5 30C22.5 30 25 27.5 25 24.5V12C25 11.4 25.4 11 26 11C26.6 11 27 11.4 27 12V24.5C27 28.6 23.6 32 19.5 32Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgPaperclip);
export default ForwardRef;
